import { isV2Enabled } from './isV2Enabled';

export const isV2LayoutEnabled = () => isV2Enabled('REACT_APP_FEATURE_TOGGLE_NEW_LAYOUT_ENABLED');
